// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scrtable[data-v-2a5068ad] {\n  display: block;\n  overflow: auto;\n  max-height: 400px\n}\n.scrVsltable[data-v-2a5068ad] {\n  display: block;\n  overflow: auto;\n  max-height: 400px\n}\n.popup_wrap[data-v-2a5068ad]::-webkit-scrollbar { display: none;\n}\n.popup_wrap[data-v-2a5068ad]{ -ms-overflow-style: none;\n}\n\n", ""]);
// Exports
module.exports = exports;
